import { render } from "./productImport.vue?vue&type=template&id=a489aa46&scoped=true"
import script from "./productImport.vue?vue&type=script&lang=js"
export * from "./productImport.vue?vue&type=script&lang=js"

import "./productImport.vue?vue&type=style&index=0&id=a489aa46&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a489aa46"],['__file',"src/views/brand/components/productImport.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a489aa46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a489aa46', __exports__)) {
    console.log('reload')
    api.reload('a489aa46', __exports__)
  }
  
  module.hot.accept("./productImport.vue?vue&type=template&id=a489aa46&scoped=true", () => {
    console.log('re-render')
    api.rerender('a489aa46', render)
  })

}


export default __exports__